import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";
import moment from "moment";

const addClinic = (fields,sendWelcomeEmail) => {
  let fullZip = fields.zip + (fields?.zipOpt ? fields?.zipOpt : "")
  const data = {
    domainName: fields.domainName,
    clinicName: fields.clinicName,
    address: fields.address,
    state: fields.state?.shortName,
    city: fields.city,
    zip: fullZip,
    phone: fields.phone,
    fax: fields.fax,
    email: fields.email,
    npi: fields.npi,
    taxId: fields.taxId,
    websiteUrl: fields.websiteUrl,
    regionId: fields.regionId.id,
    maxAllowedUserSeats: fields.userSeats,
    sendWelcomeEmail:sendWelcomeEmail,
    userSeatsPriceId:fields?.userSeatsPrice?.stripePriceId,
    oneTimeSetupPriceId:fields?.oneTimeSetupPrice?.stripePriceId,
    subscriptionStartDate: (fields?.subscriptionStartDate && fields?.subscriptionStartDate !=="Invalid date") ? moment(fields?.subscriptionStartDate).format("MM/DD/YYYY"):null,
    isRCM: fields.isRCM,
    commissionPercentage: fields.commissionPercentage,
    salesPerson: fields.salesPerson,
    referral: fields.referral,
    isActive : fields?.clinicStatus?.isActive ? fields.clinicStatus?.isActive: true,
  };
  return ApiHelper.postRequest(API_URLS.INSERT_CLINIC, data);
};

const updateClinic = (fields, state) => {
  let fullZip = fields.zip + (fields?.zipOpt ? fields?.zipOpt : "")
  const data = {
    domainName: fields.domainName,
    id: fields.id,
    masterClinicId: state.id,
    clinicName: fields.clinicName,
    address: fields.address,
    state: fields.state?.shortName,
    city: fields.city,
    zip: fullZip,
    phone: fields.phone,
    fax: fields.fax,
    email: fields.email,
    npi: fields.npi,
    taxId: fields.taxId,
    websiteUrl: fields.websiteUrl,
    maxAllowedUserSeats: fields.userSeats,
    isRCM: fields.isRCM,
    commissionPercentage: fields.commissionPercentage,
    salesPerson: fields.salesPerson,
    referral: fields.referral,
    isActive : fields?.clinicStatus?.isActive ? fields.clinicStatus?.isActive: true,
  };
  return ApiHelper.putRequest(API_URLS.UPDATE_CLINIC, data);
};

const getAllClinic = (payload) => {
  return ApiHelper.postRequest(API_URLS.GET_CLINIC_BY_REGION, payload);
};

const getDocumentTemplateByClinic = (regionData, masterClinicId) => {
  return ApiHelper.getRequest(
    API_URLS.GET_DOCUMENT_TEMPLATES_BY_CLINIC + "clinicId=" + masterClinicId + "&" + "regionId=" + regionData,
    {}
  );
};

const searchDocumentTemplate = (regionData, masterClinicId, searchQuery) => {
  return ApiHelper.getRequest(
    API_URLS.SEARCH_DOCUMENT_TEMPLATE_BY_NAME + "searchContents=" + searchQuery + "&" + "clinicId=" + masterClinicId + "&" + "regionId=" + regionData,
    {}
  );
};

const deleteClinic = (selectedId) => {
  return ApiHelper.deleteRequest(API_URLS.DELETE_CLINIC + selectedId.id);
};

const getClinicById = (selectedId) => {
  return ApiHelper.getRequest(API_URLS.GET_CLINIC_BY_ID + selectedId.id);
};

const updateClinicStatus = (data) => {
  return ApiHelper.putRequest(`${API_URLS.UPDATE_CLINIC_STATUS}?masterClinicId=${data.masterClinicId}&isActive=${data.isActive}`);
};

const getClinicInfo = (state) => {
  return ApiHelper.getRequest(`${API_URLS.GET_CLINIC_INFO}?clinicId=${state.field.masterClinicId}&regionId=${state.field.regionId}`);
};

const getClinicTemplateInfo = (dateObject) => {
  return ApiHelper.postRequest(API_URLS.GET_CLINIC_TEMPLATE_INFO, dateObject);
};
const getClinicBillingInfo = (dateObject) => {
  return ApiHelper.postRequest(API_URLS.GET_CLINIC_BILLING_INFO, dateObject);
};

const getClinicContactInfo = (regionData, masterClinicId) => {
   return ApiHelper.getRequest(`${API_URLS.GET_CLINIC_CONTACT_INFO}?clinicId=${masterClinicId}&regionId=${regionData}`);
 };
 const DeleteClinicContact = (selectedId, regionId) => {
  return ApiHelper.deleteRequest(`${API_URLS.DELETE_CLINIC_CONTACT}?id=${selectedId}&regionId=${regionId}`);
}
const getClinicContactById = (state,regionId) => {
  return ApiHelper.getRequest(`${API_URLS.GET_CLINIC_CONTACT_INFO_BY_ID}?id=${state.id}&regionId=${regionId}`);
};

const getStripeCustomerInfo = (stripeCustomerId) => {
  return ApiHelper.getRequest(`${API_URLS.GET_STRIPE_CUSTOMER_INFO}?stripeCustomerId=${stripeCustomerId}`);
};

const getStripeProduct = () => {
  return ApiHelper.getRequest(`${API_URLS.GET_STRIPE_PRODUCTS}`);
};

const getUserSeatsPriceList = (stripeProductId) => {
  return ApiHelper.getRequest(`${API_URLS.GET_PRODUCTS_PRICE}?stripeProductId=${stripeProductId}`);
};

const getOneTimeSetupPriceList = (stripeProductId) => {
  return ApiHelper.getRequest(`${API_URLS.GET_PRODUCTS_PRICE}?stripeProductId=${stripeProductId}`);
};

const addClinicContact = (fields,regionId,masterClinicId) => {
  const data = {
  name: fields.name,
  phone: fields.phone,
  email: fields.email,
  clinicId: masterClinicId,
  isPrimary: fields.isPrimary,
  regionId: regionId
}
  return ApiHelper.postRequest(API_URLS.INSERT_CLINIC_CONTACT, data);
};

const GetClinicSmsUsage = (masterClinicId, startDate, endDate) => {
  return ApiHelper.getRequest(
    API_URLS.GET_CLINIC_SMS_USAGE + "?" + "masterClinicId=" + masterClinicId  + "&" + "startDate=" + startDate + "&" + "endDate=" + endDate,
  );
};

const updateClinicContact = (fields, state,regionId,masterClinicId) => {
  const data = {
    id:state.id,
    name: fields.name,
    phone: fields.phone,
    email: fields.email,
    clinicId:masterClinicId,
    isPrimary: fields.isPrimary,
    regionId: regionId
  }
  return ApiHelper.putRequest(API_URLS.UPDATE_CLINIC_CONTACT, data);
};

const getAllClinicStates = () => {
  return ApiHelper.getRequest(API_URLS.GET_ALL_CLINIC_STATES);
};

const getCustomerStatuses = () => {
  return ApiHelper.getRequest(API_URLS.GET_CUSTOMER_STATUSES);
};

const updateCustomerStatuses = (clinicIds, customerStatusId) => {
  return ApiHelper.postRequest(API_URLS.UPDATE_CUSTOMER_STATUSES, { clinicIds, customerStatusId });
};

export const clinicService = {
  addClinic,
  getAllClinic,
  deleteClinic,
  updateClinic,
  getClinicById,
  getDocumentTemplateByClinic,
  searchDocumentTemplate,
  updateClinicStatus,
  getClinicInfo,
  getClinicTemplateInfo,
  getClinicBillingInfo,
  getClinicContactInfo,
  DeleteClinicContact,
  getClinicContactById,
  addClinicContact,
  updateClinicContact,
  getAllClinicStates,
  getCustomerStatuses,
  updateCustomerStatuses,
  getStripeCustomerInfo,
  getStripeProduct,
  getUserSeatsPriceList,
  getOneTimeSetupPriceList,
  GetClinicSmsUsage
};
